<template>
  <div class="layout-product-description bg-light">
    <div v-if="long" class="py-5 text-lg font-medium text-center px-gap">
      <div class="max-w-md mx-auto">
        <slot></slot>
      </div>
    </div>
    <div v-if="detail" v-show="opened" class="border-t border-solid p-gap sm:p-8 border-black/10 content">
      <div
          :style="{
          maxHeight: hidden ? `${maxHeight}px` : undefined
        }"
          class="overflow-hidden"
      >
        <slot name="description"></slot>
      </div>
      <!-- <div @click="hidden = false" class="mt-3 text-sm font-semibold underline cursor-pointer" v-if="hidden">
        Подробнее
      </div> -->
    </div>
    <div
        v-if="detail"
        @click="toggleDescription"
        class="block py-2 text-sm font-medium text-center underline border-t border-solid cursor-pointer"
    >
      {{ hidden ? 'Подробное описание' : 'Свернуть описание' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    long: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opened: true,
      hidden: false,
      maxLines: 3,
      lineHeight: 0,
      maxHeight: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkHide()
    })
  },
  methods: {
    toggle() {
      this.opened = !this.opened
      // if (this.opened) {
      //   this.$nextTick(() => {
      //     this.checkHide()
      //   })
      // }
    },
    toggleDescription() {
      this.hidden = !this.hidden
    },
    checkHide() {
      const content = this.$el.querySelector('.content')
      if (!content) {
        return
      }
      const lineHeight = parseInt(window.getComputedStyle(content).lineHeight)
      const height = content.clientHeight
      const lines = height / lineHeight
      const hidden = lines > this.maxLines
      this.hidden = hidden
      this.maxHeight = lineHeight * this.maxLines - 4
    }
  }
}
</script>